import { useMemo } from 'react';
import { useRouter } from 'next/router';

import GroupsIcon from '@mui/icons-material/Groups';
import RadioButtonUncheckedIcon from '@mui/icons-material/RadioButtonUnchecked';
import LabelIcon from '@mui/icons-material/Label';
import AccountBoxIcon from '@mui/icons-material/AccountBox';

import { parseQueryValue, sortArray } from '@utils';

import {
  STATUS_OPTIONS,
  TEAMS,
} from 'components/communication/CommunicationFilters/constants';
import { SIDE_FILTERS_ENUM } from 'components/communication/CommunicationSideBar/constants';

const VIEWS = [
  { text: 'Inbox', value: SIDE_FILTERS_ENUM.Inbox },
  { text: 'Sent', value: SIDE_FILTERS_ENUM.Sent, showDivider: true },
  {
    text: 'Contact Form',
    value: SIDE_FILTERS_ENUM['Contact Form'],
  },
  {
    text: 'Get Accept',
    value: SIDE_FILTERS_ENUM['Get Accept'],
  },
  {
    text: 'B2B',
    value: SIDE_FILTERS_ENUM.B2B,
  },
  {
    text: 'Buy Contact Form',
    value: SIDE_FILTERS_ENUM['Buy Contact Form'],
  },
  {
    text: 'BoxNow',
    value: SIDE_FILTERS_ENUM.BoxNow,
  },
  {
    text: 'Delivery Failures',
    value: SIDE_FILTERS_ENUM['Delivery Failures'],
  },
  {
    text: 'Automated',
    value: SIDE_FILTERS_ENUM.Automated,
  },
];

const useMyIssuesMailboxFilterConfig = ({ mailBoxes }) => {
  const router = useRouter();

  const currentFilters = useMemo(() => {
    return {
      teams: parseQueryValue(router.query.teams),
      status: parseQueryValue(router.query.status),
      labels: parseQueryValue(router.query.labels),
      mailboxId: parseQueryValue(router.query.mailboxId),
    };
  }, [router.query]);
  const teamsOptions = sortArray(TEAMS);
  const filterCategories = useMemo(
    () => [
      {
        id: 'mailboxId',
        label: 'Mailboxes',
        icon: AccountBoxIcon,
        options: mailBoxes,
        multiSelect: false,
      },
      {
        id: 'teams',
        label: 'Teams',
        icon: GroupsIcon,
        options: teamsOptions,
        multiSelect: true,
      },
      {
        id: 'status',
        label: 'Status',
        icon: RadioButtonUncheckedIcon,
        options: STATUS_OPTIONS,
        multiSelect: true,
      },
      {
        id: 'labels',
        label: 'Views',
        icon: LabelIcon,
        options: VIEWS,
        multiSelect: false,
      },
    ],
    [teamsOptions, mailBoxes]
  );

  return {
    filterCategories,
    currentFilters,
  };
};

export default useMyIssuesMailboxFilterConfig;
